import { ReactNodeViewRenderer } from "@tiptap/react"

import { BaseAttachmentNode } from "../BaseAttachment/extension"
import { IssueTypeAttachmentNodeComponent } from "./Component"

export const IssueTypeAttachmentNode = BaseAttachmentNode.extend({
	addNodeView() {
		return ReactNodeViewRenderer(IssueTypeAttachmentNodeComponent)
	},
})
